export default "__VITE_ASSET__edfc0643__"